"use strict";

var spacing = require('./spacing');
var colors = require('./colors');
var headerCrateProportion = 40;
var contentCrateProportion = 100 - headerCrateProportion;
module.exports = {
  // Float Labels
  floatLabelFontSizeMobile: {
    value: '1.6rem'
  },
  floatLabelActiveFontSizeMobile: {
    value: '1.3rem'
  },
  floatLabelFontSizeDesktop: {
    value: '1.9rem'
  },
  floatLabelActiveFontSizeDesktop: {
    value: '1.4rem'
  },
  // Forms
  formHorizontalPadding: {
    value: spacing['space-3'].value
  },
  // Crate Layout
  // Defined in vw units to make the layout more stable, and to prevent
  // scrollbars on ContentCrate from affecting the proportions.
  headerCrateProportion: {
    value: "".concat(headerCrateProportion, "vw")
  },
  contentCrateProportion: {
    value: "".concat(contentCrateProportion, "vw")
  },
  // Left padding applied to header crate inner at different screen sizes.
  'md-navTextInset': {
    value: '9.6rem'
  },
  'xl-navTextInset': {
    value: '11.2rem'
  },
  // Nav bar height
  navBarHeightMobile: {
    value: '74px'
  },
  navBarHeightDesktop: {
    value: '106px'
  },
  // Gloval nav height
  // Needed as long as the global nav has to be fixed position in desktop mode
  globalNavHeightXs: {
    value: '64px'
  },
  globalNavHeightMobile: {
    value: '72px'
  },
  globalNavHeightTablet: {
    value: '83px'
  },
  globalNavHeightDesktop: {
    value: '99px'
  },
  globalSubnavHeight: {
    value: '53px'
  },
  // Cards
  cardBorderRadius: {
    value: '12px'
  },
  cardBoxShadow: {
    value: '0px 0px .5px 0px rgba(0,0,0,0.14), 0px 1px 1px 0px rgba(0,0,0,0.24)'
  },
  cardBackgroundColor: {
    value: colors.canonical.colorWhite.value
  },
  columnWidthSmall: {
    value: '343px'
  },
  columnWidthMedium: {
    value: '500px'
  },
  columnWidthLarge: {
    value: '720px'
  },
  columnWidthXLarge: {
    value: '1440px'
  },
  // animation properties
  defaultAnimationEntranceDuration: {
    value: '300ms'
  },
  defaultAnimationExitDuration: {
    value: '200ms'
  },
  defaultAnimationEasing: {
    value: 'cubic-bezier(0.25, 0.1, 0.25, 1)'
  },
  // SVC Cards
  // Proportional rounded corners which will work at any size to mimic a physical Starbucks card's rounded corners.
  // The math for this proportion is as follows:
  // Full image size: 480px x 302px
  // Border radius at full size: 16px
  // 16 / 480 = 0.03333 (3.333%)
  // 16 / 302 = 0.05298 (5.298%)
  svcRoundedCorners: {
    value: '3.3333%/5.298%'
  },
  //  Multiple drop shadows are not created like box-shadows,
  //  ie. box-shadow: shadow1, shadow2;
  //  Instead create multiple drop-shadow entries.
  svcShadowFilter: {
    value: 'drop-shadow(0px 4px 1px rgba(0,0,0,0.11)) drop-shadow(0px 0px 2px rgba(0,0,0,0.24))'
  }
};